module.exports = __webpack_public_path__ + "static/media/SF-11-A.39cfb5ee.mp3";